import { useState } from 'react';

/**
 * Paging for a list the screen already holds whole (an API that answers every row at once): the rows of the page shown, and
 * `ListTable`'s `pagination` for them, 25, 50 or 100 a page like every list screen. A page past the end (after a search or a
 * delete) falls back to the last one.
 */
export function useLocalPages<T>(rows: readonly T[], pageSize = 25) {
  const [paging, setPaging] = useState({ page: 1, pageSize });
  const last = Math.max(1, Math.ceil(rows.length / paging.pageSize));
  const page = Math.min(paging.page, last);
  const first = (page - 1) * paging.pageSize;
  return {
    rows: rows.slice(first, first + paging.pageSize),
    /** Back to the first page, e.g. when the search changes. */
    reset: () => setPaging((p) => ({ ...p, page: 1 })),
    pagination: {
      page,
      pageSize: paging.pageSize,
      total: rows.length,
      onChange: ({ page: next, pageSize: size }: { page: number; pageSize: number }) => setPaging({ page: next, pageSize: size }),
    },
  };
}
